import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ClanStore from './store';
import cx from 'classnames';
import SimpleSwiper from '@src/components/swiper/simple-swiper';
import Link from '@src/components/link';

const styles = require('./index.less');

const Clan = ({ store }) => {
  store.use();

  const doubleSwiperList = [...Object.keys(store.swiperList), ...Object.keys(store.swiperList)];

  return (
    <div className={styles.clan}>
      <div className={cx(styles.swiper, store.isActive && styles.active)}>
        {/* <SimpleSwiper params={store.params} key={doubleSwiperList.length}>
          {doubleSwiperList.map((key, index) => {
            const item = store.swiperList[key] || {};
            return (
              <div className={cx(styles.swiperItem, styles[key])} key={index}>
                <img className={cx(styles.bg, 'bg')} src={item.bg} alt={item.name} data-name="背景图" />
                {item.bg_video && <video className={cx(styles.video, 'bg')} src={item.bg_video} autoPlay loop muted />}
                <img className={cx(styles.color, 'color')} src={item.color} alt={item.name} data-name="水墨+颜色图" />
                <div className={cx(styles.roleBox, 'roleBox')}>
                  <img className={cx(styles.role, 'role')} src={item.role} alt={item.name} data-name="角色图" />
                </div>
                <img className={cx(styles.foreground, 'foreground')} src={item.foreground} alt={item.name} data-name="前景图" />
                <img className={cx(styles.title, 'title')} src={item.title} alt={item.name} data-name="标题图" />
                <img className={cx(styles.weapon, 'weapon')} src={item.weapon} alt={item.name} data-name="武器图" />
                <img className={cx(styles.verse, 'verse')} src={item.verse} alt={item.name} data-name="诗句图" />
                <img className={cx(styles.leida, 'leida')} src={item.leida} alt={item.name} data-name="雷达图" />
              </div>
            );
          })}
        </SimpleSwiper> */}
        {doubleSwiperList.map((key, index) => {
          const item = store.swiperList[key] || {};
          return (
            <div className={cx(styles.swiperItem, styles[key], store.currentKey === index ? styles.active : '')} key={index}>
              <img className={cx(styles.bg, 'bg')} src={item.bg} alt={item.name} data-name="背景图" />
              {item.bg_video && <video className={cx(styles.video, 'bg')} src={item.bg_video} autoPlay loop muted />}
              <img className={cx(styles.color, 'color')} src={item.color} alt={item.name} data-name="水墨+颜色图" />
              <div className={cx(styles.roleBox, 'roleBox')}>
                <img className={cx(styles.role, 'role')} src={item.role} alt={item.name} data-name="角色图" />
              </div>
              <img className={cx(styles.foreground, 'foreground')} src={item.foreground} alt={item.name} data-name="前景图" />
              <img className={cx(styles.title, 'title')} src={item.title} alt={item.name} data-name="标题图" />
              <img className={cx(styles.weapon, 'weapon')} src={item.weapon} alt={item.name} data-name="武器图" />
              <img className={cx(styles.verse, 'verse')} src={item.verse} alt={item.name} data-name="诗句图" />
              <img className={cx(styles.leida, 'leida')} src={item.leida} alt={item.name} data-name="雷达图" />
            </div>
          );
        })}
      </div>
      {store.showSwiper && (
        <div className={styles.clanTabs}>
          <Link className={cx(styles.swiperBtn, styles.prev)} onClick={() => store.changeSwiper('prev')} />
          <Link className={cx(styles.swiperBtn, styles.next)} onClick={() => store.changeSwiper('next')} />
          <SimpleSwiper params={store.paramsTabs} key={doubleSwiperList.length}>
            {doubleSwiperList.map((key, index) => {
              const item = store.swiperList[key];
              return (
                <div className={cx(styles.clanTab, styles[key])} key={index} data-index={index}>
                  <img className={cx(styles.tab)} src={item.tab} alt={item.name} data-name="标签图" />
                  <img className={cx(styles.tab, styles.tabActive)} src={item.tabActive} alt={item.name} data-name="标签图" />
                  <div className={styles.activeBox} />
                </div>
              );
            })}
          </SimpleSwiper>
        </div>
      )}

      <div className={styles.iconDown} />
    </div>
  );
};

export default wrapStore(Clan, ClanStore);
